import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}
export const ProductIconEMobility: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 119 117.6" style={{ color }} xmlSpace="preserve">
      <g fill="currentColor">
        <path d="M24.9,112.2c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4s5.4,2.4,5.4,5.4C30.3,109.8,27.9,112.2,24.9,112.2
          C24.9,112.2,24.9,112.2,24.9,112.2 M24.9,96c-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8
          C35.7,100.8,30.9,96,24.9,96C24.9,96,24.9,96,24.9,96"/>
        <path d="M95.4,112.2c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4c3,0,5.4,2.4,5.4,5.4c0,0,0,0,0,0C100.8,109.8,98.3,112.2,95.4,112.2
           M95.4,96c-6,0-10.8,4.8-10.8,10.8c0,6,4.8,10.8,10.8,10.8c6,0,10.8-4.8,10.8-10.8c0,0,0,0,0,0C106.2,100.8,101.3,96,95.4,96
          C95.4,96,95.4,96,95.4,96"/>
        <path d="M89,81.2c-4.8-6.9-35.5-34.3-65.6,0h-3.2C11.2,87.7,5.6,98,5,109.1h6.6c-0.1-0.8-0.2-1.5-0.2-2.3c0-7.5,6-13.5,13.5-13.5
          s13.5,6,13.5,13.5c0,0.8-0.1,1.6-0.2,2.3h43.9c-1.2-7.4,3.8-14.3,11.2-15.5c7.2-1.2,14,3.6,15.4,10.7c0.3,1.6,0.3,3.2,0,4.7H119
          C119,109.1,121.8,83.6,89,81.2z M59.7,83.7H26C35.1,73.3,45,68,55.4,68c1.4,0,2.9,0.1,4.3,0.3L59.7,83.7z M62.8,83.7V68.9
          c11.6,2.8,20.5,11.3,22.8,14.7H62.8z"/>
        <path d="M7,90.3c-6.4-11.5-2.2-26,9.3-32.4c3.6-2,7.5-3,11.6-3h59.2c11.2,0,20.3-7.1,20.3-15.7s-9.1-15.8-20.3-15.8H38.5v4.1h48.6
          c8.8,0,16.3,5.3,16.3,11.7s-7.5,11.7-16.3,11.7H27.9C12.5,50.9,0,63.3,0,78.7c0,5.6,1.7,11.2,4.9,15.8C5.5,93.1,6.2,91.7,7,90.3"/>
        <rect y="39.1" width="35.1" height="7.1"/>
        <path d="M30.6,0H4.4C3.6,0,2.9,0.7,2.9,1.5c0,0,0,0,0,0V37h29.3V1.5C32.2,0.7,31.5,0,30.6,0L30.6,0z M22,25.3l-4.6,6.1
          c-0.1,0.2-0.4,0.3-0.6,0.3c-0.1,0-0.2,0-0.3,0c-0.3-0.1-0.6-0.4-0.6-0.8v-3.7h-1.5c-0.5,0-0.8-0.4-0.8-0.8c0-0.2,0.1-0.4,0.2-0.5
          l4.8-6.2c0.2-0.3,0.6-0.4,1-0.3c0.3,0.1,0.6,0.5,0.5,0.9L19.6,24h1.8c0.5,0,0.8,0.4,0.8,0.8C22.2,25,22.1,25.2,22,25.3z M27,13.7
          H8.1V5H27V13.7z"/>
      </g>
    </svg>
  );
}
